<template>
    <div>
        <div v-for="(row, index) in wylie" :key="index">
            <div
                    v-for="(item, index) in row"
                    :key="'item'+index"
                    class="wylie-key"
                    @click="_clickWylie(Object.getOwnPropertyNames(item)[0])"
            >
                <span class="wylie-key-tibetan">{{item[Object.getOwnPropertyNames(item)[0]]}}</span> / <span class="wylie-key-english">{{Object.getOwnPropertyNames(item)[0]}}</span>
            </div>
        </div>
    </div>
</template>

<script>

  const _wylie = [
    [
      {k: "ཀ"},
      {kh: 'ཁ'},
      {g: 'ག'},
      {ng: 'ང'},
    ],[
        {c: "ཅ"},
        {ch: "ཆ"},
        {j: "ཇ"},
        {ny: "ཉ"},
      ],[
        {t: "ཏ"},
        {th: "ཐ"},
        {d: "ད"},
        {n: "ན"},
      ],[
        {p: "པ"},
        {ph: "ཕ"},
        {b: "བ"},
        {m: "མ"},
      ],[
        {ts: "ཙ"},
        {tsh: "ཚ"},
        {dz: "ཛ"},
        {w: "ཝ"},
      ],[
        {zh: "ཞ"},
        {z: "ཟ"},
        {"'": "འ"},
        {y: "ཡ"},
      ],[
        {r: "ར"},
        {l: "ལ"},
        {sh: "ཤ"},
        {s: "ས"},
      ],[
        {h: "ཧ"},
        {a: "ཨ"},
        {i: "ཨི"},
        {e: "ཨེ"},
      ],[
        {o: "ཨོ"},
        {u: "ཨུ"}
      ]
    ];

  export default {
    name: 'Match',
    props: {
      clickWylie: Function
    },
    data() {
      return {
        wylie: _wylie,
      }
    },
    components: {
    },
    methods: {
      _clickWylie(item) {
        this.clickWylie(item);
      }
    },
    computed: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
